import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { TrialLifecycleStateContract } from '../trial-lifecycle.types';

export interface GetTrialLifecycleConflictsResponse {
  data: TrialLifecycleStateContract[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface GetTrialLifecycleConflictsParams {
  page?: number;
  limit?: number;
}

export const getTrialLifecycleConflicts = async (
  params?: GetTrialLifecycleConflictsParams,
) => {
  const response = await baseAPI.get<GetTrialLifecycleConflictsResponse>(
    '/trialstudents/lifecycle-conflicts',
    { params },
  );
  return response.data;
};

export const getTrialLifecycleConflictsQueryOptions = (
  params?: GetTrialLifecycleConflictsParams,
) =>
  queryOptions({
    queryKey: QUERY_KEYS.TRIAL_LIFECYCLE_CONFLICTS(params),
    queryFn: () => getTrialLifecycleConflicts(params),
  });

export const useGetTrialLifecycleConflicts = (
  params?: GetTrialLifecycleConflictsParams,
) => {
  return useQuery(getTrialLifecycleConflictsQueryOptions(params));
};
